const spinner = {
    appendSpinner($element = $('.page-content')) {
        $element.prepend(spinner.spinnerTemplate());
    },

    spinnerTemplate() {
        return `<div id="rb-spinner">
                <img src="/_ui/responsive/theme-rbmc/images/spinner/rb-spinner.svg">
            </div>`
    },

    spinnerVisibility(visible = false) {
        const rbSpinner = $('#rb-spinner');
        visible ? rbSpinner.fadeIn(200)
                : rbSpinner.fadeOut(200);
    }
};

spinner.appendSpinner();

export default spinner;
